import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";
import type { CustomerPaymentMethod } from "@/app/_checkout/types";

export const CONTRACT_PAYMENT_METHODS_KEY = "contract-payment-methods";

// GET contracts/{contract}/payment-methods →
//   { data: [ { id, type: 'customer-payment-methods', attributes: {...} } ] }
// Flattened into the shared (flat) CustomerPaymentMethod shape.
interface RawPaymentMethod {
  id: string | number;
  type: "customer-payment-methods";
  attributes: Omit<CustomerPaymentMethod, "id" | "type">;
}

export function useContractPaymentMethodsService(
  contractId: string | number | undefined,
) {
  return useQuery<CustomerPaymentMethod[]>({
    queryKey: [CONTRACT_PAYMENT_METHODS_KEY, contractId],
    queryFn: async () => {
      const res = await axiosInstance().get(
        `contracts/${contractId}/payment-methods`,
      );
      const items: RawPaymentMethod[] = res.data?.data ?? [];
      return items.map((item) => ({
        id: item.id,
        type: item.type,
        ...item.attributes,
      }));
    },
    enabled: !!contractId,
    staleTime: Infinity,
    retry: false,
  });
}
